(function () {
    "use strict";

    Controllers.PictimeRedirectController = class PictimeRedirectController extends Controllers.BaseControllerES6 {
        // @ngInject
        constructor($scope, $injector) {
            super($scope, $injector);
            this.__objectType = 'PictimeRedirectController';
        }
    };

}());

